const sliders =  {
    _sliderObjects: [],

    init() {
        if(document.querySelectorAll('.swiper') === 0) {
            return;
        }

        let self = this;
        const scriptUrl = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
        const cssUrl = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';

        window.initPackages([scriptUrl, cssUrl]).then(() => {
            self._constructSliders();
        }).catch((error) => {
            console.error(error);
        });

    },

    reInit() {
        let self = this;
        if(self._sliderObjects.length > 0) {
            self._sliderObjects.forEach(slider => {
                slider.destroy();
            });

            self._sliderObjects = [];
        }
        self.init();
    },

    _constructSliders() {
        let self = this;
        let headerSlider = document.querySelector('.js-header-slider');
        let cardSliders = document.querySelectorAll('.js-card-slider');
        let highLightSliders = document.querySelectorAll('.js-highlight-slider');

        if(headerSlider) {
            self._buildHeaderSlider(headerSlider);
        }

        if(cardSliders.length > 0) {
            self._buildCardSliders(cardSliders);
        }

        if(highLightSliders.length > 0) {
            self._buildHighLightSliders(highLightSliders);
        }
    },

    _buildHeaderSlider(headerSlider) {
        let self = this;

        let slider = new Swiper(headerSlider, {
            loop: true,
            effect: 'slide',
            autoplay: {
                delay: 7500,
            },
            speed: 800,
            pagination: {
                el: ".js-header-slider__pagination",
                clickable:true
            },
        });

        self._sliderObjects.push(slider);
    },

    _buildCardSliders(cardSliders) {
        let self = this;

        cardSliders.forEach((cardSlider, index) => {
            let slider = new Swiper(cardSlider, {
                slidesPerView: 1,
                spaceBetween: 24,
                rewind: true,
                autoplay: {
                    delay: 5000,
                },
                breakpoints:{
                    576: {
                        slidesPerView: 2,

                    },
                    992: {
                        slidesPerView: 3,
                    }
                },
                loop: true,
                pagination: {
                    el: ".js-card-slider__pagination",
                    clickable:true
                },
                navigation: {
                    nextEl: ".js-card-slider__next",
                    prevEl: ".js-card-slider__prev",
                  },
            });

            self._sliderObjects.push(slider);
        });
    },

    _buildHighLightSliders(highLightSliders) {
        let self = this;

        highLightSliders.forEach((highLightSlider, index) => {
            let slider  = new Swiper(highLightSlider, {
                slidesPerView: 2,
                spaceBetween: 24,
                loop: true,
                autoplay: {
                    delay: 5000,
                },
                breakpoints:{
                    576: {
                        slidesPerView: 3,
                    },
                    992: {
                        slidesPerView: 5,
                    }
                },
                pagination: {
                    el: ".js-highlight-slider__pagination",
                    clickable:true
                },
            });

            self._sliderObjects.push(slider);
        });
    },
}

sliders.init();
document.addEventListener('LokiRequestEnd', function () {
    sliders.reInit();
});
